import API_URLS from '../config/apiConfig';
import { apiGet } from '../utils/apiUtils';
import { ErrorHandler } from '../utils/errorHandler';
import type { AdminAllStoresQuery, AdminAllStoresResponse } from '../types/features/adminAllStores';

const buildQueryString = (params: AdminAllStoresQuery): string => {
  const searchParams = new URLSearchParams();
  if (params.subscription_status) searchParams.set('subscription_status', params.subscription_status);
  return searchParams.toString();
};

class AdminAllStoresService {
  private baseUrl = API_URLS.GET_ADMIN_ALL_STORES;

  async getAllStores(params: AdminAllStoresQuery): Promise<AdminAllStoresResponse> {
    try {
      const query = buildQueryString(params);
      const url = query ? `${this.baseUrl}?${query}` : this.baseUrl;
      const response = await apiGet(url);
      return response as AdminAllStoresResponse;
    } catch (error) {
      console.error('Failed to fetch admin all stores:', error);
      ErrorHandler.handleApiError(error, 'Failed to fetch stores');
      throw error;
    }
  }
}

const adminAllStoresService = new AdminAllStoresService();
export default adminAllStoresService;
